import type { Namespace } from "@/i18n/types";
import nsSheetEN from "./en";
import nsSheetJA from "./ja";

export const nsSheet = {
  name: "sheet",
  locales: {
    ja: nsSheetJA,
    en: nsSheetEN,
  },
} satisfies Namespace<"sheet", typeof nsSheetJA>;
